<template>
  <footer class="py-4 bottom-0" style="background-color: #292929">
    <div class="container mx-auto px-4">
      <div class="w-full flex flex-col md:flex-row items-center justify-between gap-4">
        <img src="@/assets/footer1.png" class="h-[53px] w-auto" />
        <img src="@/assets/footer2.png" class="h-[53px] w-auto" />
      </div>
      <p class="text-sm text-center text-white">
        © 2026 QREventos.com
      </p>
    </div>
  </footer>
</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'FooterSection',
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },
}

</script>